import { AdBanner } from "./AdBanner.js";
import type { ReactNode } from "react";


interface TallAdBannerProps {
    children?: ReactNode;
}


export function TallAdBanner({ children }: TallAdBannerProps) {
    return (
        <AdBanner
            siteID="129640"
            formatID="20"
            className="flex h-full max-w-40 flex-col items-center overflow-hidden [&_div]:grow-0 [&_p]:mt-auto [&_p]:mb-0 [&_p]:max-w-full">

            {children}
        </AdBanner>
    );
}
